// Keep loaded history while replacing matching rows and appending newly received messages.
export function mergeChatMessages(history, latest) {
  const rows = new Map(history.map(row => [String(row.id), row]));
  latest.forEach(row => rows.set(String(row.id), row));
  return Array.from(rows.values());
}
